import { ProductUsage, ProductUsageItem } from '@vi-succ/products-domain';
import { UsageItem } from '../entity/usage';
import { environment } from '../environments/environment';
import { ProductImageFactory } from './product-image.factory';

export class ProductUsageFactory {
  static build(usageItems: UsageItem[], materialNumber: string): ProductUsage {
    const imageFactory = new ProductImageFactory(environment.backend.resourcesUrl);
    const usages: ProductUsageItem[] = usageItems.map((usageItem) => {
      const newVar: ProductUsageItem = {
        path: usageItem.path.map((pathItem) => ({
          materialNumber: pathItem.materialNumber,
          //TODO: materialDescription: pathItem.materialDescription,
          positionNumber: 'ABCDEF',
        })),
        source: {
          baseDevice: usageItem.source.positionTypeGroup === 'LUMF',
          bom: [],
          features: [],
          currency: usageItem.source.conditionUnit,
          documents: usageItem.source.documents,
          grossPrice: usageItem.source.conditionValue ?? 42,
          ibau: usageItem.source.materialType === 'IBAU',
          materialDescription: usageItem.source.shortText,
          materialLongDescription: usageItem.source.longText,
          materialGroup: usageItem.source.materialGroup,
          materialNumber: usageItem.source.materialNumber,
          netPrice: 42,
          originalObject: usageItem.source,
          productImages: imageFactory.build(usageItem.source.documents),
          sparePart: usageItem.source.sparePart,
          wearPart: usageItem.source.wearPart,
          sales: usageItem.source.sellable,
          materialType: usageItem.source.materialType,
          showAvailability: usageItem.source.showAvailability,
          sellableHint: usageItem.source.sellableHint,
          showPrice: usageItem.source.showPrice,
          shoppingCartState: usageItem.source.shoppingCartState,
        },
      };
      return newVar;
    });

    return {
      materialNumber,
      usages,
    };
  }
}
